import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=bf71ffe0&scoped=true&"
import script from "./refund.js?vue&type=script&lang=js&"
export * from "./refund.js?vue&type=script&lang=js&"
import style0 from "./refund.scss?vue&type=style&index=0&id=bf71ffe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf71ffe0",
  null
  
)

export default component.exports